import { createBrowserRouter } from "react-router-dom";
import auth from "../pages/auth";
import Error404 from "../pages/Error/Error404";
import DeviceManager from"../pages/DeviceManager/DeviceManager";
import SimManagement from "../pages/SimManagement/SimManagement";
import MainLayout from "../pages/MainLayout/MainLayout";
import { Navigate } from "react-router-dom";
import UserManagement from "../pages/UserManagement/UserManagement";
import Dealers from "../pages/Dealers/dealers";
import Account from "../pages/Account/Account";
import VinJourneyPage from "../pages/VinJourney/VinJourneyTabs";
import KycDetails from "../pages/KycDetails/KycDetail";
import EoltReports from "../pages/EoltReports/EoltReports"; 
import CertificateManager from "../pages/CertificationManager/CertificateTabs";
import CertificateExpiry from "../pages/CertificateExpiry/CertificateExpiry";
import SupportContact from "../pages/SupportContact/SupportContact";
import PdCases from "../pages/PdCases/PdCases";
import AIS140Requests from "../pages/AIS140Requests/AIS140Requests";
import VinKycLogs from "../pages/VinKycLogs/VinKycLogsPage";
import NeftKyc from "../pages/NeftKyc/NeftKyc";
import PermissionGuard from "../pages/auth/PermissionGuard";
import Forbidden from "../pages/Error/Forbidden";
import TicketDetails from "../pages/DealerTicketDetails/DealerTickets";
import { PaymentsDashboard } from "../pages/Payment/Payment";


const router = createBrowserRouter([
  { path: "/login", element: <auth.Login />, errorElement: <><Error404 /></> },
  { path: "/forbidden", element: <Forbidden /> },
  { path: "/", element: <Navigate to="/login" replace /> },
  {
    path: "/",
    element: <auth.Protected />,
    children: [
      // { path: "logout", element: <auth.Logout /> },
      {
        path: "", 
        element: <PermissionGuard><MainLayout /></PermissionGuard>,
        children: [
          {path: "device-manager", element: <DeviceManager /> },
          {path: "sim-management", element: <SimManagement /> },
          {path:"dealers", element:<Dealers/>},
          {path: "kyc-details", element: <KycDetails /> },
          {path: "vin-journey", element: <VinJourneyPage /> }, 
          {path: "certificate-manager", element: <CertificateManager /> },
          {path: "certificate-expiry", element: <CertificateExpiry /> },
          {path: "eolt-reports", element: <EoltReports/> },
          {path: "user-management", element: <UserManagement /> },
          {path:"ais-tickets", element:<AIS140Requests/>},
          {path:"dealer-tickets", element:<TicketDetails/>},
          {path:"vin-imei-logs", element:<VinKycLogs/>},
          {path:"neft-kyc", element:<NeftKyc/>},
          {path:"payments", element:<PaymentsDashboard/>},
          {path: "support-contact", element: <SupportContact /> },
          {path: "pd-cases", element: <PdCases /> },
          {path: "account", element: <Account /> },
          
        ]
      },

    ],
  },
  { path: "*", element: <Error404 /> },
]);

export default router;

